import { useApiMutation } from '../useApiMutation';
import { operationsClient, apiPost } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import type { AvailabilityDaysBody, AvailabilityDaysResponse } from '@/types/scheduler';

/**
 * Scheduling v2 — day-level availability for ALL_DAY / DAY_FLEXIBLE visits
 * (POST /availability/days). Mutation-style like useConflictCheck: the search
 * takes a JSON body and fires on demand (the wizard's "Find days" button), so
 * results aren't cached under a query key. Errors are surfaced by the caller.
 */
export function useAvailabilityDays() {
  return useApiMutation<AvailabilityDaysResponse, AvailabilityDaysBody>({
    mutationFn: (dto) =>
      apiPost<AvailabilityDaysResponse, AvailabilityDaysBody>(
        operationsClient,
        schedulerEndpoints.availabilityDays(),
        dto,
      ),
    showErrorToast: false,
  });
}
